const types = {
  SET_FREEFORM_LOADING: "doSetFormConfigLoading",
  SET_FREEFORM_CONFIG: "doSetFormConfig",
  SET_FREEFORM_FIELD_VALUE: "doSetFormFieldValue",
};

export default types;
